import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { LoginScene } from './scenes/LoginScene';
import { CharacterSelectScene } from './scenes/CharacterSelectScene';
import { TownScene } from './scenes/TownScene';
import { FieldScene } from './scenes/FieldScene';
import { DungeonScene } from './scenes/DungeonScene';
import { AudioManager } from './systems/AudioManager';

// PRD_SystemDesign 2.1 - Phaser 3 WebGL renderer (fallback Canvas)
let gameInstance: Phaser.Game | null = null;

export function getGame(): Phaser.Game | null {
  return gameInstance;
}

export function startGame(parent: HTMLElement): Phaser.Game {
  const config: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    parent,
    width: 1280,
    height: 720,
    backgroundColor: '#0b0d12',
    physics: {
      default: 'arcade',
      arcade: { gravity: { x: 0, y: 0 }, debug: false },
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    fps: { target: 60, forceSetTimeOut: false },
    scene: [
      BootScene,
      PreloadScene,
      LoginScene,
      CharacterSelectScene,
      TownScene,
      FieldScene,
      DungeonScene,
    ],
  };
  return new Phaser.Game(config);
}

export function startGameOnce(parent: HTMLElement): Phaser.Game {
  if (!gameInstance) {
    gameInstance = startGame(parent);
    AudioManager.init();
  }
  return gameInstance;
}
